import { PageContext } from 'vike/types';
import { parse } from 'cookie';

export function determineNavigationMode(pageContext: PageContext): 'buy' | 'rent' {
  let effectiveMode: 'buy' | 'rent' = 'buy'; // Default

  // 1. Route parameter preference
  // Check if routeParams.mode exists and is 'rent' or 'buy'
  if (pageContext.routeParams?.mode === 'rent' || pageContext.routeParams?.mode === 'buy') {
    effectiveMode = pageContext.routeParams.mode;
  } else {
    // 2. Cookie preference
    const cookieHeader = pageContext.isClientSide ? document.cookie : pageContext.headers?.cookie || '';
    const cookies = parse(cookieHeader);
    const cookieMode = cookies['openroom-nav-mode'];
    if (cookieMode === 'rent' || cookieMode === 'buy') {
      effectiveMode = cookieMode;
    }
  }
  return effectiveMode;
}
